import ScrollReveal from "./ScrollReveal";

const PROJECTS = [
  {
    id: 1,
    title: "Cuisine blanche → chêne clair",
    before: "/images/cuisine3-avant.jpeg",
    after: "/images/cuisine3-apres.jpeg",
  },
  {
    id: 2,
    title: "Cuisine beige → bleue",
    before: "/images/cuisine1-avant.jpg",
    after: "/images/cuisine1-apres.jpg",
  },
  {
    id: 3,
    title: "Plan de travail foncé → clair",
    before: "/images/cuisine2-avant.jpg",
    after: "/images/cuisine2-apres.jpg",
  },
];

export default function BeforeAfterSlider() {
  return (
    <section
      id="avant-apres"
      data-testid="before-after-section"
      className="py-24 lg:py-36 bg-[#0273DB]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <ScrollReveal>
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              Avant / Après : le choc visuel
            </h2>
            <p className="text-white/70 max-w-2xl mx-auto">
              Découvrez comment une cuisine peut être transformée sans travaux.
            </p>
          </div>
        </ScrollReveal>

        <div className="space-y-12">
          {PROJECTS.map((project) => (
            <ScrollReveal key={project.id}>
              <div className="bg-white/10 rounded-3xl p-4 lg:p-6 backdrop-blur">
                <h3 className="text-white text-lg font-semibold mb-4 text-center">
                  {project.title}
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="relative">
                    <img
                      src={project.before}
                      alt={`Avant rénovation - ${project.title}`}
                      className="w-full h-full object-cover rounded-2xl"
                    />
                    <div className="absolute top-3 left-3 bg-black/70 text-white text-xs px-3 py-1 rounded-full">
                      AVANT
                    </div>
                  </div>

                  <div className="relative">
                    <img
                      src={project.after}
                      alt={`Après rénovation par Vinylux - ${project.title}`}
                      className="w-full h-full object-cover rounded-2xl"
                    />
                    <div className="absolute top-3 left-3 bg-white text-[#0273DB] text-xs px-3 py-1 rounded-full">
                      APRÈS
                    </div>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}